import { CART_API_URL, CART_ID_COOKIE_NAME, CART_QUANTITY_URL } from "../../../api/consts";
import { selectHeader } from "../../common";
export var selectCartData = function selectCartData(state) {
  return selectHeader(state).cart;
};
export var selectCartApiUrl = function selectCartApiUrl(state) {
  var _selectCartData;
  return ((_selectCartData = selectCartData(state)) === null || _selectCartData === void 0 ? void 0 : _selectCartData.apiUrl) || CART_API_URL;
};
export var selectCartQuantityUrl = function selectCartQuantityUrl(state) {
  var _selectCartData2;
  return ((_selectCartData2 = selectCartData(state)) === null || _selectCartData2 === void 0 ? void 0 : _selectCartData2.quantityUrl) || CART_QUANTITY_URL;
};
export var selectCartShouldInitialize = function selectCartShouldInitialize(state) {
  var _selectCartData3;
  return ((_selectCartData3 = selectCartData(state)) === null || _selectCartData3 === void 0 ? void 0 : _selectCartData3.shouldInitialize) || true;
};
export var selectCartCookieName = function selectCartCookieName(state) {
  var _selectCartData4;
  return ((_selectCartData4 = selectCartData(state)) === null || _selectCartData4 === void 0 ? void 0 : _selectCartData4.cookieName) || CART_ID_COOKIE_NAME;
};
export var selectCartHref = function selectCartHref(state) {
  var _selectCartData5;
  return ((_selectCartData5 = selectCartData(state)) === null || _selectCartData5 === void 0 ? void 0 : _selectCartData5.href) || '/basket';
};
export var selectCartQuantity = function selectCartQuantity(state) {
  var _selectCartData6;
  return ((_selectCartData6 = selectCartData(state)) === null || _selectCartData6 === void 0 ? void 0 : _selectCartData6.quantity) || 0;
};
export var selectHasCart = function selectHasCart(state) {
  return typeof selectCartQuantity(state) === 'number' && selectCartQuantity(state) > 0;
};